module.exports = __webpack_public_path__ + "static/media/catalog.dcc91c4c.svg";